module.exports = new __parcel__URL__("LeftLobby1.f625efe5.hdr").toString();